/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `use_case` - use_case
 * * `ai_model` - ai_model
 * @export
 */
export const TargetModelEnum = {
  useCase: 'use_case',
  aiModel: 'ai_model',
} as const;
export type TargetModelEnum = (typeof TargetModelEnum)[keyof typeof TargetModelEnum];

export function instanceOfTargetModelEnum(value: any): boolean {
  for (const key in TargetModelEnum) {
    if (Object.prototype.hasOwnProperty.call(TargetModelEnum, key)) {
      if ((TargetModelEnum as Record<string, TargetModelEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function TargetModelEnumFromJSON(json: any): TargetModelEnum {
  return TargetModelEnumFromJSONTyped(json, false);
}

export function TargetModelEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): TargetModelEnum {
  return json as TargetModelEnum;
}

export function TargetModelEnumToJSON(value?: TargetModelEnum | null): any {
  return value as any;
}
